export default __webpack_public_path__ + "3fa1b517fec117000c7493f5b699236e.png";